import request from '../../lib/helpers/requestApi';
import { ClientsList, ParamClients, ParamSetStatus } from './types';

export const getClients = request<ClientsList, ParamClients>({
  method: 'partner.getClients',
});
export const setStatusClient = request<boolean, ParamSetStatus>({
  method: 'partner.setStatus',
});
